





































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { DealShipment } from '@/models/filebunker/shipment';
import { Base } from '@/components/common/base';
import { getDealLeaseInfoHeaders, getDealTradeInfoHeaders } from '@/views/fileBunker/deal/deal';
import {dealService,attachmentService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
  },
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class DealLeasePage extends Base {
  public headers: VHeaders[] = getDealLeaseInfoHeaders(this);
  public headersTrades: VHeaders[] = getDealTradeInfoHeaders(this);
  public $moment: any;
  public pagination = new PaginationModel('trackingId');
  public loading: boolean = false;

  public stockNumber: string;
  public actions: any[] = [];
  public dealLease: any={};

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'deals');
    
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.stockNumber = this.$route.params.stockNumber;
    this.getDealLease();
  }

    public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('dealTracking.btnBackToList') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('dealTracking.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }

  public async getDealLease(): Promise<void> {
    try {
      this.loading = true;
      this.dealLease = await dealService.getDeadLease(this.stockNumber);
    } finally {
      this.loading = false;
    }
  }


  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.deals' });
    }
  }
}
